import script from "./startup-application-possible-previous-applications.vue?vue&type=script&setup=true&lang=ts"
export * from "./startup-application-possible-previous-applications.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__